/**
 * Explorar
 *
 * @author edmsamuel
 */
import React from 'react';
import { Icon } from 'antd';

export default class Explorar extends React.Component {
  render() {
    return (
      <div className='container clear'>
        <div className='content center-childs' style={{ flex: 1 }}>
          <h1><Icon type='meh-o' /></h1>
          <h2>La pagina que busca no se encuentra</h2>
        </div>
      </div>
    );
  }
}
